// The backend ObjectMapper registers JavaTimeModule without disabling WRITE_DATES_AS_TIMESTAMPS,
// so LocalDate serialises as [year, month, day] and OffsetDateTime as fractional epoch seconds.
// These normalise both at the point a response enters the app, so components and query params only
// ever see ISO-8601 strings. Remove once the mapper emits ISO directly.

const pad = (value) => String(value).padStart(2, "0");

export const toIsoDate = (value) => {
  if (!Array.isArray(value)) {
    return value ?? null;
  }
  const [year, month, day] = value;
  return `${year}-${pad(month)}-${pad(day)}`;
};

export const toIsoDateTime = (value) => {
  if (typeof value !== "number") {
    return value ?? null;
  }
  return new Date(value * 1000).toISOString();
};
